
// src/web/components/user-templates-panel.jsx

import TemplatesPanel from './templates-panel.jsx'
import connect from '../../connects/user-templates-panel'

export default connect(TemplatesPanel)



// WEBPACK FOOTER //
// ./src/web/components/user-templates-panel.jsx